/* eslint-disable no-unused-vars */
"use strict";

import Vue from "vue";
import axios from "axios";
import NProgress from "nprogress";

import "nprogress/nprogress.css";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.baseURL = import.meta.env.baseURL || import.meta.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Pending AJAX request tracker — Playwright can wait for #ajax-pending to be detached
let _pendingRequests = 0;

function _updatePendingIndicator() {
    let el = document.getElementById("ajax-pending");
    if (_pendingRequests > 0) {
        if (!el) {
            el = document.createElement("div");
            el.id = "ajax-pending";
            el.setAttribute("data-count", _pendingRequests);
            el.style.display = "none";
            document.body.appendChild(el);
        } else {
            el.setAttribute("data-count", _pendingRequests);
        }
    } else if (el) {
        el.remove();
    }
}

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // baseURL: import.meta.env.baseURL || import.meta.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
    paramsSerializer: {
        serialize: (params) => {
            // Properly serialize arrays as key[]=value1&key[]=value2
            // Other objects are converted to JSON strings for backward compatibility
            const searchParams = new URLSearchParams();
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const value = params[key];
                    if (Array.isArray(value)) {
                        // Handle arrays properly - send as key[]=val1&key[]=val2
                        value.forEach(item => {
                            searchParams.append(key + '[]', item);
                        });
                    } else if (typeof value === 'object' && value !== null) {
                        // Non-array objects are JSON stringified
                        searchParams.append(key, JSON.stringify(value));
                    } else if (value !== undefined && value !== null) {
                        searchParams.append(key, value);
                    }
                }
            }
            return searchParams.toString();
        }
    }
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        NProgress.start();
        _pendingRequests++;
        _updatePendingIndicator();
        return config;
    },
    function (error) {
        // Do something with request error
        NProgress.done();
        _pendingRequests = Math.max(0, _pendingRequests - 1);
        _updatePendingIndicator();
        return Promise.reject(error);
    },
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        NProgress.done();
        _pendingRequests = Math.max(0, _pendingRequests - 1);
        _updatePendingIndicator();
        return response;
    },
    function (error) {
        // Do something with response error
        NProgress.done();
        _pendingRequests = Math.max(0, _pendingRequests - 1);
        _updatePendingIndicator();
        return Promise.reject(error);
    },
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            },
        },
        $axios: {
            get() {
                return _axios;
            },
        },
    });
};

Vue.use(Plugin);

export default Plugin;
